// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 128 ? "539a0f1b" : chunkId) + "." + {"128":"29b8a64375a0ddac","389":"48048e7bcd5c3b11","651":"9078e83f25d7ee7c","741":"cd9485d61f910928"}[chunkId] + ".js";
};